import React from 'react';
import { Routes, Route } from 'react-router-dom';
import {
  AuthLayout,
  GlobalProvider,
  MainLayout,
  OnboardingLayout,
} from './layouts';
import {
  SignUp,
  Login,
  EmailVerification,
  ForgotPassword,
  ForgotPasswordVerification,
  Home,
  Chat,
  Matches,
  Profile,
  ResetPassword,
  OnboardingSummaryPage,
  OnboardingAISummaryPage,
  Settings,
  OnboardingMatches,
  AgentReview,
  OnboardingPage,
  ConversationalOnboardingPage,
  DiscoverPage,
  AdminHealthPage,
  AdminMatchingPage,
  OAuthLaunchPage,
  OAuthRelayPage,
  ConnectSignInPage,
  NotFound,
} from './pages';
import { routes } from './lib/routes';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <GlobalProvider>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path={routes.home} element={<Home />} />
          <Route path={routes.chat} element={<Chat />} />
          {/* Jun-18 (a user V1 test, P4 follow-up): /ai-conversation route
              removed. AI-to-AI conversation is out of scope; its only entry
              point (the match-card "AI Conversation" button) was removed too,
              so the page is no longer reachable. The aichat module + route
              constant remain as dead code for a later full cleanup. */}
          <Route path={routes.matches} element={<Matches />} />
          <Route path={routes.profile} element={<Profile />} />
          <Route path={routes.settings} element={<Settings />} />
          <Route path={routes.agentReview} element={<AgentReview />} />
          <Route path={routes.discover} element={<DiscoverPage />} />
          {/* Admin Dashboard */}
          <Route path={routes.adminHealth} element={<AdminHealthPage />} />
          <Route path={routes.adminMatching} element={<AdminMatchingPage />} />
        </Route>

        <Route element={<OnboardingLayout />}>
          <Route path={routes.onboarding} element={<OnboardingPage />} />
          <Route path={routes.onboardingChat} element={<ConversationalOnboardingPage />} />
          <Route
            path={routes.onboardingSummary}
            element={<OnboardingSummaryPage />}
          />
          <Route
            path={routes.onboardingAISummary}
            element={<OnboardingAISummaryPage />}
          />
          <Route
            path={routes.onboardingMatches}
            element={<OnboardingMatches />}
          />
        </Route>

        <Route element={<AuthLayout />}>
          <Route path={'/'} element={<Login />} />
          <Route path={routes.login} element={<Login />} />
          <Route path={routes.signup} element={<SignUp />} />
          <Route
            path={routes.emailVerification}
            element={<EmailVerification />}
          />
          <Route
            path={routes.forgotPasswordVerification}
            element={<ForgotPasswordVerification />}
          />
          <Route path={routes.forgotPassword} element={<ForgotPassword />} />
          <Route path={routes.resetPassword} element={<ResetPassword />} />
        </Route>

        {/* V1.5.M10 B-P2: white-label cross-subdomain Google sign-in relay.
            Standalone (no layout): transitional, self-branded pages. */}
        <Route path={routes.oauthLaunch} element={<OAuthLaunchPage />} />
        <Route path={routes.oauthRelay} element={<OAuthRelayPage />} />
        <Route path={routes.connect} element={<ConnectSignInPage />} />

        {/* BUG-022 FIX: Show 404 page instead of silent redirect */}
        <Route path='*' element={<NotFound />} />
      </Routes>

      <Toaster position='top-right' containerClassName='custom-toast' />
    </GlobalProvider>
  );
}

export default App;
